interface ConfigErrorProps {
  missing: string[];
  message: string;
}

/**
 * Deliberately dependency-free and token-free: it has to render when configuration
 * is broken, which is exactly when you cannot assume anything else loaded.
 */
export function ConfigError({ missing, message }: ConfigErrorProps) {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        fontFamily: 'ui-rounded, -apple-system, system-ui, sans-serif',
        background: '#FAFAFC',
        color: '#111113',
      }}
    >
      <main style={{ maxWidth: 480, textAlign: 'left' }}>
        <h1 style={{ fontSize: 22, fontWeight: 600, letterSpacing: '-0.017em', margin: '0 0 8px' }}>
          Configuration error
        </h1>
        <p style={{ margin: '0 0 16px', color: '#6E6E78', fontSize: 15, lineHeight: 1.5 }}>
          The app could not read its runtime configuration from <code>/env.js</code>.
        </p>
        {missing.length > 0 && (
          <ul style={{ margin: '0 0 16px', paddingLeft: 20, fontSize: 15 }}>
            {missing.map((key) => (
              <li key={key}>
                <code>{key}</code> is missing or empty
              </li>
            ))}
          </ul>
        )}
        <pre
          style={{
            margin: 0,
            padding: 12,
            borderRadius: 10,
            background: 'rgba(0,0,0,0.05)',
            fontSize: 13,
            whiteSpace: 'pre-wrap',
          }}
        >
          {message}
        </pre>
      </main>
    </div>
  );
}
